import { staticSettings } from "@montana/helpers/static-settings.helper";
import { createServiceFunction } from "../http";
import {
    IAddCustomerInformationRequest,
    IUpdateShippingInformationRequest
} from "@montana/models/generated/cms.interface";

export const getCountries = createServiceFunction((marketId: string) => {
    const url = `${staticSettings.apiUrl}/api/checkout/countries/${marketId}`;

    return f =>
        f(url, {
            method: "GET"
        });
});

export const postPersonalInformation = createServiceFunction(
    (cartId: string, customerInformation: IAddCustomerInformationRequest) => {
        const url = `${staticSettings.apiUrl}/api/checkout/cart/${cartId}/personalinformation`;

        return f =>
            f(url, {
                method: "POST",
                body: JSON.stringify(customerInformation),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    }
);

export const getPersonalInformation = createServiceFunction(
    (cartId: string) => {
        const url = `${staticSettings.apiUrl}/api/checkout/cart/${cartId}/personalinformation`;

        return f =>
            f(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    }
);

export const getShippingInformation = createServiceFunction(
    (cartId: string) => {
        const url = `${staticSettings.apiUrl}/api/checkout/cart/${cartId}/shippinginformation`;

        return f =>
            f(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    }
);

export const postShippingInformation = createServiceFunction(
    (
        cartId: string,
        shippingInformation: IUpdateShippingInformationRequest
    ) => {
        const url = `${staticSettings.apiUrl}/api/checkout/cart/${cartId}/shippinginformation`;

        return f =>
            f(url, {
                method: "POST",
                body: JSON.stringify(shippingInformation),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    }
);

export const getParcelShops = createServiceFunction(
    (zipCode: string, marketId: string) => {
        const url = `${staticSettings.apiUrl}/api/checkout/shippinginformation/parcelshops/${marketId}/${zipCode}`;

        return f =>
            f(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    }
);

export const postCartToPayment = createServiceFunction((cartId: string) => {
    const url = `${staticSettings.apiUrl}/api/checkout/cart/${cartId}/payment`;

    return f =>
        f(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
});

export const getOrderInformation = createServiceFunction((orderId: string) => {
    const url = `${staticSettings.apiUrl}/api/checkout/order/summary?orderId=${orderId}`;

    return f =>
        f(encodeURI(url), {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
});

export const getCityMatchingZipCode = createServiceFunction(
    (zipCode: string, marketId: string) => {
        const url = `${staticSettings.apiUrl}/api/checkout/cart/city/${marketId}/${zipCode}`;
        return f =>
            f(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            });
    }
);
